var map = {
	"./angel.png": "86b7",
	"./ball1.png": "2baf",
	"./ball2.png": "2436",
	"./ball3.png": "c58f",
	"./bone.png": "4d40",
	"./clothes1.png": "b3a9",
	"./clothes2.png": "4d76",
	"./collar1.png": "0a3f",
	"./collar2.png": "9f89",
	"./collar3.png": "1d92",
	"./collar4.png": "e015",
	"./devil.png": "a765",
	"./doggo.png": "8307",
	"./food1.png": "b3a0",
	"./food2.png": "d6d7",
	"./hat1.png": "0d87",
	"./hat2.png": "98a4",
	"./hat3.png": "dc7a",
	"./hat4.png": "6c8c",
	"./napkin1.png": "4515",
	"./napkin2.png": "3d34",
	"./napkin3.png": "55e9",
	"./napkin4.png": "822c",
	"./ribbon1.png": "1da1",
	"./ribbon2.png": "ecd7",
	"./shoes1.png": "7c72",
	"./shoes2.png": "d09a",
	"./shoes3.png": "12a7",
	"./shoes4.png": "79a7",
	"./tshirt1.png": "97e0",
	"./tshirt2.png": "702a",
	"./tshirt3.png": "c3e1",
	"./tshirt4.png": "0448",
	"./tshirt5.png": "27de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b29";